import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { EFB_LOCAL_STORAGE_NAME, useLocalStorage } from '../../hocs/useLocalStorage';
import { EFB_DEFAULT_LANGUAGE, Languages } from '../../locale/constants';

export const useLanguageToggle = () => {
    const [value, setValue] = useLocalStorage(EFB_LOCAL_STORAGE_NAME, EFB_DEFAULT_LANGUAGE);
    const { i18n } = useTranslation();

    const handleToggleLanguage = useCallback(() => {
        setValue((prevValue) => {
            const currentIndex = Languages.indexOf(prevValue);
            const nextIndex = (currentIndex + 1) % Languages.length;
            const nextLanguage = Languages[nextIndex];
            i18n.changeLanguage(nextLanguage);

            return nextLanguage;
        });
    }, [i18n, setValue]);

    useEffect(() => i18n.changeLanguage(value), []);

    return { currentLanguage: value, handleToggleLanguage };
};
